export const cateogrySeoMeta = {
  "personal-injury": {
    title: "Arizona Personal Injury Lawyers | The Husband & Wife Law Team",
    meta: "The Husband and Wife Law Team are top personal injury lawyers in Arizona & NM helping injured accident victims since 1996. 928-543-1112. We Win or It’s Free.",
    h1: "Arizona Personal Injury Lawyers"
  },

  "truck-accidents": {
    title: "Arizona Truck Accident Injury Lawyers | The Husband & Wife Law Team",
    meta: "Injured in an trucking accident? Our Arizona truck accident injury lawyers at The Husband & Wife Law Team will help you fight for the money you deserve. Call 928-543-1112 for a free consultation! We Win or It’s Free. Serving AZ & NM.",
    h1: "Arizona Truck Accident Injury Lawyers"
  },

  "car-accidents": {
    title: "Arizona Car Accident Injury Lawyers | The Husband & Wife Law Team",
    meta: "Injured in an auto accident? Call our Arizona car accident injury lawyers at The Husband & Wife Law Team to help fight for the money you deserve 928-543-1112. Free consultation. We Win or It’s Free.",
    h1: "Arizona Car Accident Injury Lawyers"
  },

  "motorcycle-accidents": {
    title: "Arizona Motorcycle Accident Injury Lawyers | The Husband & Wife Law Team",
    meta: "The Husband and Wife Law Team are top motorcycle accident injury lawyers in Arizona & NM, helping injured bike accident victims since 1996. (928) 543-1112. We Win or It’s Free.",
    h1: "Arizona Motorcycle Accident Injury Lawyers"
  },
};
